import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {onboardingSessions} from './api_session';
import {getAdditionalProps} from '../../../../services/proto/core/loginProps';
import {onboardingMessageStore} from '../../store/OB_Message_Store';

export const handleMessage = (
    messages: priority.netitems.shared.IMessage[],
    Session?: string,
    ConfirmCallback?: () => void
) => {
    if (messages.length > 0) {
        const msg = messages[0];

        onboardingMessageStore.setMessage({
            message: msg,
            Session,
            ConfirmCallback
        });
        if (msg.MType) {
            throw msg.Text;
        }
    }
};

export const approveWarning = async (Session: string) => {
    try {
        const res = await wcfclient.warningApprove(
            new priority.netitems.form.WarningApproveRq({
                Properties: getAdditionalProps(),
                Session
            })
        );

        await handleMessage(res.Messages, Session);
        return res;
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export const getForm = async (formName: string) => {
    try {
        const data = onboardingSessions.getFormByKey(formName);

        if (!data) {
            const form = await wcfclient.start(
                new priority.netitems.form.StartRq({
                    Fname: formName,
                    Properties: getAdditionalProps()
                })
            );

            handleMessage(form.Messages, form.Session);

            const cols = await wcfclient.columns(
                new priority.netitems.form.ColumnsRq({
                    Session: form.Session,
                    Properties: getAdditionalProps()
                })
            );

            handleMessage(cols.Messages, form.Session);

            if (cols.Columns.length > 0) {
                onboardingSessions.setFormSession(formName, form, cols);
            }
            return {form, cols};
        }

        return data;
    } catch (e) {
        onboardingSessions.removeFormByKey(formName);
        throw new Error((e as Error).message);
    }
};

export const getSubForm = async (Session: string, Keys, subFormName: string) => {
    try {
        const subformRes = await wcfclient.subform(
            new priority.netitems.form.SubformRq({
                Session,
                Keys,
                Fname: subFormName,
                Properties: getAdditionalProps()
            })
        );

        handleMessage(subformRes.Messages, Session);

        return subformRes;
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export const fetchData = async (form, Filters, Attachments?) => {
    try {
        const res = await wcfclient.recordsFetch(
            new priority.netitems.form.FetchRq({
                Session: form.Session,
                Properties: getAdditionalProps(),
                Filters,
                Attachments
            })
        );

        handleMessage(res.Messages);

        return res;
    } catch (e) {
        onboardingSessions.removeFormByKey(form.formName);
        throw new Error((e as Error).message);
    }
};

export const saveRecord = async (Session: string, msgCallback?: () => void) => {
    try {
        const recordSaveRes = await wcfclient.recordSave(
            new priority.netitems.form.RecordSaveRq({
                Session: Session,
                Properties: getAdditionalProps()
            })
        );

        await handleMessage(recordSaveRes.Messages, Session, msgCallback);

        return recordSaveRes;
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export const requestHTML = async (Session: string) => {
    try {
        const htmlRes = await wcfclient.htmlFetch(
            new priority.netitems.form.HtmlFetchRq({
                Session,
                Properties: getAdditionalProps()
            })
        );

        handleMessage(htmlRes.Messages);

        return htmlRes;
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export const getFieldHelp = async (formName: string, fieldName: string) => {
    try {
        const res = await wcfclient.help(
            new priority.netitems.form.HelpRq({
                ColName: fieldName,
                Fname: formName,
                Properties: getAdditionalProps()
            })
        );

        return res;
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export const startRecordEdit = async ({Session, ScrLine, Keys, formName}) => {
    try {
        const editRes = await wcfclient.recordEdit(
            new priority.netitems.form.RecordEditRq({
                Session,
                Properties: getAdditionalProps(),
                Keys,
                ScrLine
            })
        );

        handleMessage(editRes.Messages, Session);

        return editRes;
    } catch (e) {
        onboardingSessions.removeFormByKey(formName);

        throw new Error((e as Error).message);
    }
};

export const updateRecordField = async ({Session, ColumnID, Value, Fname}) => {
    try {
        const res = await wcfclient.fieldUpdate(
            new priority.netitems.form.FieldUpdateRq({
                Session,
                Properties: getAdditionalProps(),
                Field: {ColumnID, Value}
            })
        );

        await handleMessage(res.Messages);

        return res;
    } catch (e) {
        onboardingSessions.removeFormByKey(Fname);

        throw Error((e as Error).message);
    }
};

export const closeSession = async (Session: string, formName: string = '') => {
    try {
        const res = await wcfclient.end(
            new priority.netitems.form.EndRq({
                Session,
                Properties: getAdditionalProps()
            })
        );
        onboardingSessions.removeFormByKey(formName);

        return res;
    } catch (e) {
        onboardingSessions.removeFormByKey(formName);

        throw new Error((e as Error).message);
    }
};
